export interface FaqConfig {
    question: HTMLElement;
    answer: HTMLElement;
}

export class Faq {
    private readonly elements: {
        question: HTMLElement;
        answer: HTMLElement;
    };

    constructor({question, answer}: FaqConfig) {
        this.elements = {question, answer};
        this.init();
    }

    public toggle(): void {
        const {question, answer} = this.elements;

        question.classList.toggle(`is-active`);
        answer.style.maxHeight
            ? answer.style.maxHeight = null
            : answer.style.maxHeight = `${answer.scrollHeight}px`;
    }

    protected onQuestionKeyPressing(evt: KeyboardEvent): void {
        if (evt.key === `Enter`) this.toggle();
    }

    protected init(): void {
        const question = this.elements.question;
        question.addEventListener('click', () => this.toggle());
        question.addEventListener('keydown', (evt) => this.onQuestionKeyPressing(evt));
    }
}